export default "#map{width:100%;height:100%}#bubbles-switch{position:absolute}";